export default __webpack_public_path__ + "static/media/qr_logo.ff915e13.png";